export const ANALYTICS_SUB_SUITE_IDS = {
  // Marketing
  CHANNEL_PERFORMANCE: 'channelPerformance',
  WEB_TRAFFIC_ANALYSIS: 'webTrafficAnalysis',
  MULTI_TOUCH_ATTRIBUTION_REVENUE_IMPACT: 'multiTouchAttributionRevenueImpact',
  ATTRIBUTION: 'attribution',
  ADVANCED_MARKETING_REPORTING: 'advancedMarketingReporting',
  CRM_INSIGHTS: 'crmInsights',
  // Sales
  ACTIVITIES_AND_LEADS: 'activitiesAndLeads',
  DEALS: 'deals',
  FORECAST_AND_REVENUE: 'forecastAndRevenue',
  // Service
  TEAM_PERFORMANCE: 'teamPerformance',
  CUSTOMER_SATISFACTION: 'customerSatisfaction',
  TICKET_REPLIES: 'ticketReplies',
  SERVICE_PLANNING: 'servicePlanning',
  SELF_SERVICE_PERFORMANCE: 'selfServicePerformance',
  // Commerce
  INVOICES: 'invoices',
  SUBSCRIPTIONS: 'subscriptions',
  PAYMENTS: 'payments'
};